import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './ProjectOpenError.css';

/**
 * A project from the URL that could not be opened (useCanvasProjectContext's urlValidationError). Says why in a line and
 * offers the way on: Try again when the sandbox did not answer (`project_load_failed`), Sign in when the session
 * expired (`session_expired`, a 401), always Back to projects.
 * Replaces the old full-screen "Project Not Found" picker (a grid of every project with VFS badges).
 */
const TITLES = {
  project_not_found: 'Project not found',
  project_load_failed: 'This project could not be opened',
  tenant_mismatch: 'This project belongs to another organization',
  session_expired: 'Sign in again',
};

const signIn = () => window.location.assign(`/bff/login?redirect_uri=${encodeURIComponent(window.location.href)}`);

export default function ProjectOpenError({ error, onRetry = () => window.location.reload() }) {
  const navigate = useNavigate();
  const canRetry = error.type === 'project_load_failed';
  return (
    <div className="project-open-error" role="alert">
      <div className="project-open-error-card">
        <h1>{TITLES[error.type] || 'This project could not be opened'}</h1>
        <p>{error.message}</p>
        <div className="project-open-error-actions">
          {error.type === 'session_expired' && <Button onClick={signIn} type="primary">Sign in</Button>}
          {canRetry && <Button onClick={onRetry} type="primary">Try again</Button>}
          <Button onClick={() => navigate('/projects')} type={canRetry || error.type === 'session_expired' ? 'default' : 'primary'}>Back to projects</Button>
        </div>
      </div>
    </div>
  );
}

ProjectOpenError.propTypes = {
  error: PropTypes.shape({ type: PropTypes.string, message: PropTypes.string }).isRequired,
  onRetry: PropTypes.func,
};
